import React, { useRef } from 'react';
import { Box, Grid } from '@material-ui/core';
import { Title } from '../Procedure.styled';
import ProcedureDropdown from 'src/pages/reportUsage/procedure/components/physician/ProcedureDropdown';
import PhysicianTerritory from 'src/pages/reportUsage/procedure/components/physician/PhysicianTerritory/PhysicianTerritory';
import { sizes } from 'src/styles/Media.styled';
import { isMobileView } from 'src/utils/util';
import { useTranslation } from 'react-i18next';
import { BASE_TEXT_PX, SMALL_TEXT_PX, FONT_FAMILY_REGULAR } from 'src/styles/fonts/MCFontConstants';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import InputBox from 'src/common/refactoredComponents/input/Input';
import { MainContainerItems, RadioRowDiv } from 'src/common/components/PediatricContainer/Pediatric.styled';
import { MANDATORY, VISIBLE } from 'src/constants/appConstants';
import { logErrorToConsole } from 'src/utils/util';


const PhysicianCardView = ({
    setDropDownValue,
    dropDownValue,
    selectedPhysicianData,
    setSelectedPhysicianData,
    physicianInputValue,
    setPhysicianInputValue,
    proceduresList,
    showProcedureDropdown,
    zIndex,
    equityPadding,
    isEquity,
    marginBottom,
    countryCode,
    procedureDataPhysicianVisibility,
    procedureValue,
    isDraft,
    procedureMandatoryRule,
    isFromProcedure,
    isPediatricSurgery,
    setPediatricCheck,
    isDisabledPediatric,
    pediatricMandatoryRule,
    pediatricSurgeryVisibility,
    pediatricValue,
    isFromEquity,
    physicianTextUsageVisibility,
    physicianTextUsageMandatory,
    physicianFieldText,
    setPhysicianFieldText,
    physicianTextBoxType,
    setPhysicianTextBoxType,
    isReportUsageFlow,
}) => {
    const { t } = useTranslation();
    const physicianRef = useRef(null);

    const isValid =
        (!procedureDataPhysicianVisibility || !!physicianInputValue) &&
        (showProcedureDropdown
            ? !procedureMandatoryRule || !!dropDownValue?.procedureCode?.length
            : true) &&
        (pediatricSurgeryVisibility
            ? !pediatricMandatoryRule ||
              (pediatricValue !== '' && pediatricValue !== undefined)
            : true) &&
        (physicianTextUsageVisibility === VISIBLE
            ? physicianTextUsageMandatory !== MANDATORY ||
              physicianTextBoxType === 'unknown' ||
              !!physicianFieldText
            : true);

    const showBorder = isValid ? '1px solid #12C8F7' : '';

    return (
        <>
            <Box
                my={1}
                bgcolor={'#ffffff'}
                boxShadow={'0px 0px 6px #00000029'}
                borderRadius={5}
                padding={
                    window.innerWidth <= sizes.mobileDevice
                        ? procedureValue && !isDraft
                            ? '20px 22px 10px'
                            : equityPadding
                            ? equityPadding
                            : '20px 22px 10px 22px'
                        : '20px 32px 10px 22px'
                }
                width={'99.66%'}
                position={'relative'}
                marginLeft={'1px'}
                marginRight={'1px'}
                border={showBorder}
            >
                <Grid
                    container
                    style={{
                        paddingBottom: !isEquity && marginBottom,
                    }}
                >
                    <Grid item xs={12} md={12}>
                        <Title
                            paddingBtm={isMobileView ? '15px' : '10px'}
                            mbpaddingBtm={'20px'}
                            paddingLeft={!isMobileView && '20px'}
                            fontSize={BASE_TEXT_PX}
                        >
                            <span>
                                {t(
                                    'consignmentBilling.replen.replenListView.replenListViewMobile.details'
                                )}
                            </span>
                        </Title>
                    </Grid>
                    {procedureDataPhysicianVisibility?(
                        <Grid item lg={6} md={6} xs={12}>
                            <PhysicianTerritory
                                selectedPhysicianData={selectedPhysicianData}
                                setSelectedPhysicianData={
                                    setSelectedPhysicianData
                                }
                                physicianInputValue={physicianInputValue}
                                setPhysicianInputValue={setPhysicianInputValue}
                                zIndex={zIndex}
                                countryCode={countryCode}
                                isEquity={isEquity}
                                procedureDataPhysicianVisibility={
                                    procedureDataPhysicianVisibility
                                }
                                showProcedureDropdown={showProcedureDropdown}
                                isFromProcedure={isFromProcedure}
                                isReportUsageFlow={isReportUsageFlow}
                            />
                        </Grid>
                    ) : (physicianTextUsageVisibility === VISIBLE && (
                        <Grid item lg={6} md={6} xs={12}>
                            <Title
                                paddingBtm={'8px'}
                                mbpaddingBtm={'8px'}
                                fontSize={SMALL_TEXT_PX}
                                fontFamily={FONT_FAMILY_REGULAR}
                            >
                                {t('common.physicianLabel')}
                                {physicianTextUsageMandatory===MANDATORY&& (
                                    <span className="asterisk">*</span>
                                )}
                            </Title>
                            <Box marginLeft={window.innerWidth <= sizes.smalDevice ? '0px' : '-20px'}>
                                <RadioRowDiv
                                    marginBottom={'15px'}
                                    width={true}
                                    isFromProcedure={true}
                                >
                                    <RadioButton
                                        id="procedure-physician-text-typeKnown"
                                        isChecked={physicianTextBoxType === 'known'}
                                        label={t('common.knownLabel')}
                                        handleChange={() => {
                                            try {
                                                setPhysicianTextBoxType &&
                                                    setPhysicianTextBoxType('known');
                                                physicianRef.current?.focus();
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                        value={physicianTextBoxType}
                                        fontFamilyStyle="AvenirNextWorld Regular"
                                        fontSize={BASE_TEXT_PX}
                                    />
                                    <RadioButton
                                        id="procedure-physician-text-typeUnknown"
                                        isChecked={physicianTextBoxType === 'unknown'}
                                        label={t('common.unknownLabel')}
                                        handleChange={() => {
                                            try {
                                                setPhysicianTextBoxType &&
                                                    setPhysicianTextBoxType('unknown');
                                                physicianRef.current?.focus();
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                        value={physicianTextBoxType}
                                        fontFamilyStyle="AvenirNextWorld Regular"
                                        fontSize={BASE_TEXT_PX}
                                    />
                                </RadioRowDiv>
                            </Box>
                            <Box marginBottom={isMobileView && '20px'}>
                                <InputBox
                                    ref={physicianRef}
                                    id={'procedure-physicianCardView-physicianFieldText'}
                                    value={physicianFieldText || ''}
                                    placeholder={
                                        physicianTextBoxType === 'known'
                                            ? t('scheduleSurgery.details.physicianName')
                                            : t('scheduleSurgery.details.unknown')
                                    }
                                    onChange={(e) => {
                                        setPhysicianFieldText &&
                                            setPhysicianFieldText(
                                                e.target.value.slice(0, 120)
                                            );
                                    }}
                                    disabled={physicianTextBoxType === 'unknown'}
                                    backgroundDisabled={physicianTextBoxType === 'unknown'}
                                />
                            </Box>
                        </Grid>
                    ))}
                    <Grid item lg={6} md={6} xs={12}>
                        {showProcedureDropdown || pediatricSurgeryVisibility ? (
                            <ProcedureDropdown
                                isEquity={isEquity}
                                marginBottom={marginBottom}
                                setDropDownValue={setDropDownValue}
                                dropDownValue={dropDownValue}
                                proceduresList={proceduresList}
                                procedureValue={procedureValue}
                                procedureDataPhysician={
                                    procedureDataPhysicianVisibility||physicianTextUsageVisibility
                                }
                                isDraft={isDraft}
                                procedureMandatoryRule={procedureMandatoryRule}
                                isDisabledPediatric={isDisabledPediatric}
                                setPediatricCheck={setPediatricCheck}
                                isPediatricSurgery={isPediatricSurgery}
                                isFromProcedure={isFromProcedure}
                                pediatricMandatoryRule={pediatricMandatoryRule}
                                pediatricSurgeryVisibility={
                                    pediatricSurgeryVisibility
                                }
                                isFromEquity={isFromEquity}
                                showProcedureDropdown={showProcedureDropdown}
                            />
                        ) : null}
                    </Grid>
        
                </Grid>
            </Box>
        </>
    );
};

export default PhysicianCardView;
